export default [{
    path: 'tunnelqmxAS',
    name: 'tunnelqmxAS',
    meta: {
        title: '隧道评价汇总',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/Tunnel/tunnelAssessSummary')
},{
    path: 'tunnelqmxTSW',
    name: 'tunnelqmxTSW',
    meta: {
        title: '隧道技术状态预警',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/Tunnel/tunnelTechnicalStatusWarning')
},{
    path: 'tunnelqmxMQ',
    name: 'tunnelqmxMQ',
    meta: {
        title: '隧道养护质量',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/Tunnel/tunnelMaintenanceQuality')
},{
    path: 'tunnelqmxDDT',
    name: 'tunnelqmxDDT',
    meta: {
        title: '隧道病害趋势',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/Tunnel/publicDiseaseDevelopmentTrendCopy')
},{
    path: 'sideslopeqmxAS',
    name: 'sideslopeqmxAS',
    meta: {
        title: '边坡评价汇总',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/SidesLope/sideslopeAssessSummary')
},{
    path: 'sideslopeqmxTSW',
    name: 'sideslopeqmxTSW',
    meta: {
        title: '边坡技术状态预警',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/SidesLope/sideslopeTechnicalStatusWarning')
},{
    path: 'sideslopeqmxMQ',
    name: 'sideslopeqmxMQ',
    meta: {
        title: '边坡养护质量',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/SidesLope/sideslopeMaintenanceQuality')
},{
    path: 'sideslopeqmxDDT',
    name: 'sideslopeqmxDDT',
    meta: {
        title: '边坡病害趋势',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/SidesLope/publicDiseaseDevelopmentTrendCopy')
},{
    path: 'exportqmxRoad',
    name: 'exportqmxRoad',
    meta: {
        title: '路面决策导出',
        auth: true
    },
    component: () =>
        import ('@/views/qmx_cx/Export/ConservationProgram/index.vue')
}]